export default "__VITE_ASSET__BC4deIBO__"